"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UdpOutputStatusCode = exports.UdpInputStatusCode = exports.RtpInputStatusCode = exports.ChannelState = exports.RistOutputMultipathState = exports.RistInputMultipathState = exports.RistMultipathPolicy = exports.DelayMode = exports.Importance = exports.RistServerFecMode = void 0;
var RistServerFecMode;
(function (RistServerFecMode) {
    RistServerFecMode[RistServerFecMode["none"] = 0] = "none";
    RistServerFecMode[RistServerFecMode["1D"] = 1] = "1D";
    RistServerFecMode[RistServerFecMode["2D"] = 2] = "2D";
})(RistServerFecMode || (exports.RistServerFecMode = RistServerFecMode = {}));
// for the rist-server
var Importance;
(function (Importance) {
    Importance["vital"] = "vital";
    Importance["nonvital"] = "nonvital";
})(Importance || (exports.Importance = Importance = {}));
// for the rist-server
var DelayMode;
(function (DelayMode) {
    // basedOnRtpAndArrivalTime = 0,
    DelayMode[DelayMode["basedOnArrivalTime"] = 1] = "basedOnArrivalTime";
    DelayMode[DelayMode["basedOnOriginTime"] = 2] = "basedOnOriginTime";
})(DelayMode || (exports.DelayMode = DelayMode = {}));
// for the rist-server
var RistMultipathPolicy;
(function (RistMultipathPolicy) {
    // Of all healthy paths, the one with the highest priority is chosen.
    // The others are sent inhibit messages to prevent them from sending RTP.
    RistMultipathPolicy["failover"] = "failover";
    // No inhibit messages are sent on any input paths.
    RistMultipathPolicy["redundancy"] = "redundancy";
    // Propagate is failover with propagation of inhibit on all rist inputs
    // when all rist outputs are inhibited and no udp output is vital.
    // As soon as one rist output is resumed, propagation of inhibit stops.
    RistMultipathPolicy["propagate"] = "propagate";
})(RistMultipathPolicy || (exports.RistMultipathPolicy = RistMultipathPolicy = {}));
// for the rist-server
var RistInputMultipathState;
(function (RistInputMultipathState) {
    RistInputMultipathState["active"] = "active";
    RistInputMultipathState["standby"] = "standby";
})(RistInputMultipathState || (exports.RistInputMultipathState = RistInputMultipathState = {}));
// for the rist-server
var RistOutputMultipathState;
(function (RistOutputMultipathState) {
    RistOutputMultipathState["active"] = "active";
    RistOutputMultipathState["inhibited"] = "inhibited";
})(RistOutputMultipathState || (exports.RistOutputMultipathState = RistOutputMultipathState = {}));
var ChannelState;
(function (ChannelState) {
    ChannelState["activated"] = "activated";
    ChannelState["deactivated"] = "deactivated";
})(ChannelState || (exports.ChannelState = ChannelState = {}));
// for the rist-server
var RtpInputStatusCode;
(function (RtpInputStatusCode) {
    RtpInputStatusCode["ok"] = "ok";
    RtpInputStatusCode["oddSsrc"] = "odd_ssrc";
    RtpInputStatusCode["unknown"] = "unknown";
})(RtpInputStatusCode || (exports.RtpInputStatusCode = RtpInputStatusCode = {}));
// for the rist-server
var UdpInputStatusCode;
(function (UdpInputStatusCode) {
    UdpInputStatusCode["active"] = "active";
    UdpInputStatusCode["standby"] = "standby";
})(UdpInputStatusCode || (exports.UdpInputStatusCode = UdpInputStatusCode = {}));
// for the rist-server
var UdpOutputStatusCode;
(function (UdpOutputStatusCode) {
    UdpOutputStatusCode["playing"] = "playing";
    UdpOutputStatusCode["noData"] = "no_data";
    UdpOutputStatusCode["noOriginTime"] = "no_origin_time";
    UdpOutputStatusCode["noCommonTimeBase"] = "no_common_time_base";
    UdpOutputStatusCode["lagging"] = "lagging";
})(UdpOutputStatusCode || (exports.UdpOutputStatusCode = UdpOutputStatusCode = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmlzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9yaXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQU9BLElBQVksaUJBSVg7QUFKRCxXQUFZLGlCQUFpQjtJQUN6Qix5REFBUSxDQUFBO0lBQ1IscURBQVEsQ0FBQTtJQUNSLHFEQUFRLENBQUE7QUFDWixDQUFDLEVBSlcsaUJBQWlCLGlDQUFqQixpQkFBaUIsUUFJNUI7QUFxREQsc0JBQXNCO0FBQ3RCLElBQVksVUFHWDtBQUhELFdBQVksVUFBVTtJQUNsQiw2QkFBZSxDQUFBO0lBQ2YsbUNBQXFCLENBQUE7QUFDekIsQ0FBQyxFQUhXLFVBQVUsMEJBQVYsVUFBVSxRQUdyQjtBQXNGRCxzQkFBc0I7QUFDdEIsSUFBWSxTQUlYO0FBSkQsV0FBWSxTQUFTO0lBQ2pCLGdDQUFnQztJQUNoQyxxRUFBc0IsQ0FBQTtJQUN0QixtRUFBcUIsQ0FBQTtBQUN6QixDQUFDLEVBSlcsU0FBUyx5QkFBVCxTQUFTLFFBSXBCO0FBeUJELHNCQUFzQjtBQUN0QixJQUFZLG1CQVlYO0FBWkQsV0FBWSxtQkFBbUI7SUFDM0IscUVBQXFFO0lBQ3JFLHlFQUF5RTtJQUN6RSw0Q0FBcUIsQ0FBQTtJQUVyQixtREFBbUQ7SUFDbkQsZ0RBQXlCLENBQUE7SUFFekIsdUVBQXVFO0lBQ3ZFLGtFQUFrRTtJQUNsRSx1RUFBdUU7SUFDdkUsOENBQXVCLENBQUE7QUFDM0IsQ0FBQyxFQVpXLG1CQUFtQixtQ0FBbkIsbUJBQW1CLFFBWTlCO0FBcUJELHNCQUFzQjtBQUN0QixJQUFZLHVCQUdYO0FBSEQsV0FBWSx1QkFBdUI7SUFDL0IsNENBQWlCLENBQUE7SUFDakIsOENBQW1CLENBQUE7QUFDdkIsQ0FBQyxFQUhXLHVCQUF1Qix1Q0FBdkIsdUJBQXVCLFFBR2xDO0FBRUQsc0JBQXNCO0FBQ3RCLElBQVksd0JBR1g7QUFIRCxXQUFZLHdCQUF3QjtJQUNoQyw2Q0FBaUIsQ0FBQTtJQUNqQixtREFBdUIsQ0FBQTtBQUMzQixDQUFDLEVBSFcsd0JBQXdCLHdDQUF4Qix3QkFBd0IsUUFHbkM7QUE2SUQsSUFBWSxZQUdYO0FBSEQsV0FBWSxZQUFZO0lBQ3BCLHVDQUF1QixDQUFBO0lBQ3ZCLDJDQUEyQixDQUFBO0FBQy9CLENBQUMsRUFIVyxZQUFZLDRCQUFaLFlBQVksUUFHdkI7QUE0SkQsc0JBQXNCO0FBQ3RCLElBQVksa0JBSVg7QUFKRCxXQUFZLGtCQUFrQjtJQUMxQiwrQkFBUyxDQUFBO0lBQ1QsMENBQW9CLENBQUE7SUFDcEIseUNBQW1CLENBQUE7QUFDdkIsQ0FBQyxFQUpXLGtCQUFrQixrQ0FBbEIsa0JBQWtCLFFBSTdCO0FBRUQsc0JBQXNCO0FBQ3RCLElBQVksa0JBR1g7QUFIRCxXQUFZLGtCQUFrQjtJQUMxQix1Q0FBaUIsQ0FBQTtJQUNqQix5Q0FBbUIsQ0FBQTtBQUN2QixDQUFDLEVBSFcsa0JBQWtCLGtDQUFsQixrQkFBa0IsUUFHN0I7QUFFRCxzQkFBc0I7QUFDdEIsSUFBWSxtQkFNWDtBQU5ELFdBQVksbUJBQW1CO0lBQzNCLDBDQUFtQixDQUFBO0lBQ25CLHlDQUFrQixDQUFBO0lBQ2xCLHNEQUErQixDQUFBO0lBQy9CLCtEQUF3QyxDQUFBO0lBQ3hDLDBDQUFtQixDQUFBO0FBQ3ZCLENBQUMsRUFOVyxtQkFBbUIsbUNBQW5CLG1CQUFtQixRQU05QiJ9